import { IButtonProps, IIconProps, ISearchBoxProps, SearchBox as FabricSearchBox } from "@fluentui/react";
import React, { useEffect } from "react";

import { useDelayedState } from "../../../hooks/use-delayed-state/useDelayedState";
import { Stack } from "../../layouts/stack/Stack";

const filterIcon: IIconProps = { iconName: "Filter" };

export interface FilterTextBoxProps extends Pick<ISearchBoxProps, "placeholder" | "value"> {
    onChange(newValue?: string): void;
    testId?: string;
}

export const SearchBox: React.FunctionComponent<FilterTextBoxProps> = (props: FilterTextBoxProps) => {
    const { placeholder, value, onChange, testId } = props;

    const [delayedValue, inputValue, setInputValue] = useDelayedState(value);

    useEffect(() => {
        if (delayedValue || value) onChange(delayedValue);
    }, [delayedValue]);

    const changeValue = (_event?: React.ChangeEvent<HTMLInputElement>, newValue?: string): void => {
        setInputValue(newValue);
    };

    const buttonProps: IButtonProps = {
        id: `${testId}-clear`
    };

    return (
        <Stack style={{ width: "100%" }}>
            <FabricSearchBox
                styles={{ root: { width: "100%" } }}
                placeholder={placeholder || "Filter"}
                iconProps={filterIcon}
                onChange={changeValue}
                value={inputValue}
                underlined={true}
                data-testid={testId}
                clearButtonProps={buttonProps}
            />
        </Stack>
    );
};
